export const debugServerSessionSuffix = '##debugserver';
